module.exports = __webpack_public_path__ + "static/media/exit.289fc013.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/exit.svg
// module id = 274
// module chunks = 0